module.exports = __webpack_public_path__ + "static/media/strap_terminating.9a2db211.webp";